
import React from 'react';



type Props = {
  className?: string;
}
export const InfoVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21Z' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M12 8.5L12 12' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M11.9941 15.5H12.0031' />
    </svg>
  );
};
